import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const optimismSepolia: VToken[] = [
  {
    chainId: 11155420,
    address: '0x6149eFAd7671f496C900B3BeC16Ba31Aed60BE4b',
    decimals: 8,
    symbol: 'vWBTC_Core',
    underlyingToken: tokens[11155420][3],
  },
  {
    chainId: 11155420,
    address: '0x4E610626BeF901EEE22D558b2ed19e6f7B87cf51',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[11155420][4],
  },
  {
    chainId: 11155420,
    address: '0x2419606690B08060ebFd7581e0a6Ae45f1915ee9',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[11155420][6],
  },
  {
    chainId: 11155420,
    address: '0xC23D18536E7069f924B3717B2710CA6A09e53ea9',
    decimals: 8,
    symbol: 'vUSDT_Core',
    underlyingToken: tokens[11155420][5],
  },
  {
    chainId: 11155420,
    address: '0x49cceCdd0b399C1b13260452893A3A835bDad5DC',
    decimals: 8,
    symbol: 'vOP_Core',
    underlyingToken: tokens[11155420][2],
  },
];
